// Retouching js
$(document).on("click", ".btnrtoptn", function () {
  var parentdiv = $(this).parent();
  parentdiv.siblings().removeClass("retouching_content_active");
  parentdiv.addClass("retouching_content_active");
  $("#hdproductid").val($(this).data("id")+"_"+$(this).data("price"));

  $("#chknoretouching").prop('checked', false);
})
$(document).on("click", "#chknoretouching", function () {
  $(".retouching_content").removeClass("retouching_content_active");
})
$(document).on("click", ".nextpageret", function () {
  var qvalue = getParameterByName('productid');

  debugger;
  if($('#chknoretouching').is(":checked"))
  {
    window.location.href = "https://dikshakhnat.myshopify.com/pages/ProductFrames";
  }
  else
  {
    if($("#hdproductid").val() !="")
    {
      var pid = $("#hdproductid").val().split('_')[0];
      var value = $("#hdproductid").val().split('_')[1];

      if(value > 0)
      {
        if($(".rtext").val().length <= 0)
        {
          $(".rtext").addClass("rtext_active");        
          $('.alert-success').css("display", "block");
          $(".alert-success").delay(5000).fadeOut();          
        }
        else
        {
          var prddesc = $(".retouching_content_active").find(".descclass").text().trim();
          sessionStorage.setItem("Oct_wpid", pid);
          sessionStorage.setItem("Oct_wpdesc", prddesc);
          sessionStorage.setItem("Oct_wpextra", $(".rtext").val());
          if($('#chkproof').is(':checked'))
            sessionStorage.setItem("Oct_wpproof", "Yes");
          $(".rtext").removeClass("rtext_active");     
          window.location.href = "https://dikshakhant.myshopify.com/pages/ProductFrames?productid="+qvalue;
        }
      }
      else
      {window.location.href = "https://dikshakhant.myshopify.com/pages/ProductFrames?productid="+qvalue;}


    }
    else
    {
      $('.alert-success').text("Please select atlease one plan");
      $('.alert-success').css("display", "block");
      $(".alert-success").delay(5000).fadeOut();
    }
  }


});

// Product frames js
$(document).on("click", ".btnframe", function () {

  var parentdiv = $(this).parent();
  parentdiv.siblings().removeClass("retouching_content_active");
  parentdiv.addClass("retouching_content_active");
  $("#hdproductid").val($(this).data("id")+"_"+$(this).data("price"));
});

$(document).on("click", ".nextpagefrm", function () {
  debugger;
  var cart = 0;
  $.ajax({
    type: "GET",
    url: "/cart.js",
    cache:false,
    async: false,
    dataType: "json",
    success: function (data) {debugger;
                              cart = data.item_count;
                             }
  });
  jQuery.getJSON('/cart.js', function(cart) {
    cart = cart.item_count;
  });

  if($("#hdproductid").val() !="")
  {
    var qvalue = getParameterByName('productid');

    if(qvalue == undefined && qvalue == "")
      qvalue = "-"

      var pid = $("#hdproductid").val().split('_')[0];
    var value = $("#hdproductid").val().split('_')[1];

    if(value > 0)
    { 
      var prddesc = $(".retouching_content_active").find(".descclass").text().trim();
      var formOBJ = {
        quantity: 1,
        id: pid,
        properties: {
          '_productid': cart+qvalue,
          '_custom':'Custom'+qvalue
        }
      };

      // product Frame
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        cache:false,
        data:formOBJ,
        async: false,
        dataType: "json",
        success: function (data) {
          Shopify.onItemAdded = function(cart) {
            jQuery.getJSON('/cart.js', function(cart) {
              $('.cartCount').html(cart.item_count);
            });
          }
          var restpid = sessionStorage.getItem("Oct_wpid");
          var restpdesc = sessionStorage.getItem("Oct_wpdesc");
          var extra = sessionStorage.getItem("Oct_wpextra");
          if(extra == undefined && extra == "")
            extra = "-";
          var proof = sessionStorage.getItem("Oct_wpproof");
          if(proof == undefined && proof == "")
            proof = "No";
          if(restpid != undefined && restpid != "")
          {

            // Product option
            formOBJ = {
              quantity: 1,
              id: restpid,
              properties: {
                'Basic': restpdesc,
                'Added text': extra,
                'Send a proof':proof,
                '_productid': cart+qvalue,
                '_retouch': 'Retouch'+qvalue
              }
            };          
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              cache:false,
              data:formOBJ,
              async: false,
              dataType: "json",
              success: function (data) {
                Shopify.onItemAdded = function(cart) {
                  jQuery.getJSON('/cart.js', function(cart) {
                    $('.cartCount').html(cart.item_count);
                  });
                }
                sessionStorage.removeItem("Oct_wpid");
                sessionStorage.removeItem("Oct_wpdesc");
                sessionStorage.removeItem("Oct_wpextra");
                sessionStorage.removeItem("Oct_wpproof");
              },
              error: function (xhr, ajaxOptions, thrownError) {
                alert("error");
                console.log(xhr.status);
                console.log(thrownError);
              }
            });
          }
        },
        error: function (xhr, ajaxOptions, thrownError) {
          alert("error");
          console.log(xhr.status);
          console.log(thrownError);
        }
      });
    }
    else
    {
      var restpid = sessionStorage.getItem("Oct_wpid");
      var restpdesc = sessionStorage.getItem("Oct_wpdesc");
      var extra = sessionStorage.getItem("Oct_wpextra");
      if(extra == undefined && extra == "")
        extra = "-";
      var proof = sessionStorage.getItem("Oct_wpproof");
      if(proof == undefined && proof == "")
        proof = "No";
      if(restpid != undefined && restpid != "")
      {
        // Product option
        formOBJ = {
          quantity: 1,
          id: restpid,
          properties: {
            'Basic': restpdesc,
            'Added text': extra,
            'Send a proof':proof,
            '_productid': cart+qvalue,
            '_retouch': 'Retouch'+qvalue
          }
        };      
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          cache:false,
          data:formOBJ,
          async: false,
          dataType: "json",
          success: function (data) {               
            Shopify.onItemAdded = function(cart) {
              jQuery.getJSON('/cart.js', function(cart) {
                $('.cartCount').html(cart.item_count);
              });
            }
            sessionStorage.removeItem("Oct_wpid");
            sessionStorage.removeItem("Oct_wpdesc");
          },
          error: function (xhr, ajaxOptions, thrownError) {
            alert("error");
            console.log(xhr.status);
            console.log(thrownError);
          }
        });
      }
    }

    window.location.href = "/cart";
  }
  else
  {
    $('.alert-success').text("Please select atlease one plan");
    $('.alert-success').css("display", "block");
    $(".alert-success").delay(5000).fadeOut();
  }

});

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function RemoveBelowItems(index,prdid,id)
{  
  debugger;
  var colid = $("#col"+index);

  if(colid.text().trim().includes("retouching") || colid.text().trim().includes("productframes"))
  {
    var formOBJ = {
      line: index,
      quantity: 0
    };

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      cache:false,
      data:formOBJ,
      async: false,
      dataType: "json",
      success: function (data) {        debugger;
         
      },
      error: function (xhr, ajaxOptions, thrownError) {debugger;
        alert("There might be some problem. Please try after sometime.");
      }
    });
    //     var href = "/cart/change?line="+index+"&amp;quantity=0";
    //     window.location.href = href;
  }  
  else
  {
    var formOBJ = {
      line: index,
      quantity: 0
    };

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      cache:false,
      data:formOBJ,
      async: false,
      dataType: "json",
      success: function (data) {debugger;
          

        // First option remove
        var nxt = index - 1;
        colid = $("#col"+nxt);        
        if(colid.text().trim().includes("retouching") || colid.text().trim().includes("productframes"))
        {
          formOBJ = {
            line: nxt,
            quantity: 0
          };

          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            cache:false,
            data:formOBJ,
            async: false,
            dataType: "json",
            success: function (data) {debugger;   
               

              // Second option Remove

              var nxt1 = nxt - 1;
              colid = $("#col"+nxt1);              
              if(colid.text().trim().includes("retouching") || colid.text().trim().includes("productframes"))
              {
                formOBJ = {
                  line: nxt1,
                  quantity: 0
                };

                $.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  cache:false,
                  data:formOBJ,
                  async: false,
                  dataType: "json",
                  success: function (data) {        debugger;
                     
                  },
                  error: function (xhr, ajaxOptions, thrownError) {debugger;
                    alert("There might be some problem. Please try after sometime.");
                    console.log(xhr.status);
                    console.log(thrownError);
                  }
                });
              }
            },
            error: function (xhr, ajaxOptions, thrownError) {
              alert("There might be some problem. Please try after sometime.");
              console.log(xhr.status);
              console.log(thrownError);
            }
          });
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert("There might be some problem. Please try after sometime.");
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
  }


  window.location.replace(window.location.href);

}
jQuery(document).ready(function ($) {
  $( ".c_options_section .descclass img" ).wrap( "<div class=c_option_img></div>" );
 
});